import styled from 'styled-components';
import { styledTable } from '../styled/mixin';
import { Vendor, VendorEvaluation } from '../../modules/vendors';
import Table, { ColumnsType } from 'antd/lib/table';
import { Button, Col, Popconfirm, Row, Space } from 'antd';
import moment from 'moment';
import Title from 'antd/lib/typography/Title';

const StyledDiv = styled.div`
  ${styledTable}
`;

interface VendorEvaluationListComponentProps {
  openCreateVendorEvaluationModal: () => void;
  onDelete: (vendorEvaluationId: string) => void;
  // data: VendorEvaluation[];
  vendor: Vendor;
  currentUser: any;
}

function VendorEvaluationListComponent({
  openCreateVendorEvaluationModal,
  onDelete,
  vendor,
  currentUser,
}: VendorEvaluationListComponentProps) {
  const columns: ColumnsType<VendorEvaluation> = [
    {
      title: '평가일시',
      dataIndex: 'createdAt',
      render: (text: any, record: any, index: any) =>
        moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss'),
      width: '10%',
    },
    // {
    //   title: '공사명',
    //   dataIndex: ['details', 'projectName'],
    //   width: '20%',
    // },
    // {
    //   title: '평가상세',
    //   dataIndex: 'details',
    //   width: '30%',
    //   render: (value, record: any, index) => (
    //     <ul>
    //       {value.questions.map((question: string, index: number) => (
    //         <li key={index}>
    //           {question} / {value.answers[index]}
    //         </li>
    //       ))}
    //     </ul>
    //   ),
    // },
    {
      title: '의견',
      // dataIndex: ['details', 'comment'],
      dataIndex: 'comment',
      width: '40%',
      render: (text: any, record: any) => (
        <>
          {/* <p>{text}</p> */}
          <div style={{ whiteSpace: 'break-spaces' }}>{text}</div>
        </>
      ),
    },
    {
      title: '점수',
      dataIndex: 'score',
      width: '5%',
    },
    {
      title: '평가자',
      dataIndex: ['user', 'name'],
      width: '6%',
    },
    {
      title: '',
      key: 'action',
      align: 'center',
      width: '7%',
      render: (text, record, index) => (
        <Space size="small">
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="정말 삭제하시겠습니까?"
              data-test={`project-list-item-${index}`}
              onConfirm={() => {
                if (currentUser.id === record.user.id) {
                  onDelete(record.id + '');
                } else {
                  alert('본인이 작성한 평가만 삭제할 수 있습니다.');
                }
              }}
            >
              <Button size="small">삭제</Button>
            </Popconfirm>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <StyledDiv>
      <Row justify="space-between">
        <Col>
          <Title level={5}>업체 평가</Title>
        </Col>
        <Col>
          <Button onClick={openCreateVendorEvaluationModal} size="small">
            추가
          </Button>
        </Col>
      </Row>

      {vendor && (
        <Table<VendorEvaluation>
          rowKey="id"
          columns={columns}
          dataSource={vendor.evaluation}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '30', '50', '100', '300'],
            position: ['bottomCenter'],
          }}
        />
      )}
    </StyledDiv>
  );
}
export default VendorEvaluationListComponent;
